import { HStack, Select } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { FilterValue } from "../../../models/KPI";
import { useOrganisation } from "../../../networking/organisation.hooks";
import { t } from "i18next";
import { getWeekNumber, getWeekNumberList, getYearList } from "../../../utils/date.time.utils";
import dayjs from "dayjs";

interface Props {
	value: FilterValue;
	onChange: (data: FilterValue) => void;
	onFetch: (value: boolean) => void;
	fetch: boolean;
	isLoading: boolean;
}

const Filter = ({ value, onChange, onFetch, fetch, isLoading }: Props) => {
	const { data: organisation } = useOrganisation();

	const [year, setYear] = useState<string>(new Date().getFullYear().toString());
	const [weekNumberList, setWeekNumberList] = useState<{ name: string; key: string }[]>(
		getWeekNumberList(Number(year))
	);
	const [endYear, setEndYear] = useState<string>(dayjs().year().toString());
	const [selectedWeek, setSelectedWeek] = useState<any>(getWeekNumber(new Date()));
	const [yearList, setYearList] = useState(getYearList(3, 1));
	const [selectedDayMonth, setSelectedDayMonth] = useState<"date" | "month" | "year">("date");

	const poolOptions = useMemo(() => {
		if (organisation?.pools) {
			return [{ name: t("ALL"), key: "all" }, ...organisation.pools];
		}
		return [];
	}, [organisation, t]);

	const viewTypeOptions = [
		{ name: t("DAY"), key: "date" },
		{ name: t("MONTH"), key: "month" },
		{ name: t("YEAR"), key: "year" },
	];

	function dayMonthSelector(e: any) {
		if (e.target.value === "month") {
			const years = getYearList(3, 1);
			setYearList(years);
			setSelectedDayMonth("month");
			setYear(new Date().getFullYear().toString());
			filter(
				new Date().getFullYear().toString(),
				endYear,
				new Date().getFullYear().toString(),
				e.target.value
			);
		} else if (e.target.value === "date") {
			const years = getYearList(0, 0);
			setYearList(years);
			setYear(new Date().getFullYear().toString());
			setSelectedDayMonth("date");
			setWeekNumberList(getWeekNumberList(Number(year)));
			setSelectedWeek(getWeekNumber(new Date()));
			filter(year, endYear, getWeekNumber(new Date()).toString(), e.target.value);
		} else if (e.target.value === "year") {
			const years = getYearList(3, 1);
			setYearList(years);
			setYear(years[0].name);
			setSelectedDayMonth("year");
			const toYears = getYearList(3, 1);
			setWeekNumberList(toYears);
			setSelectedWeek(new Date().getFullYear());
			filter(years[0].name, endYear, new Date().getFullYear().toString(), e.target.value);
		}
	}

	function getPeriodText() {
		if (selectedDayMonth === "date") {
			return "(vecka)";
		} else if (selectedDayMonth === "year") {
			return "(år)";
		} else {
			return "";
		}
	}

	function filter(startDate: string, endDate: string, week: string, type?: string) {
		if (type) {
			const param = {
				...value,
				startDate: startDate,
				endDate: endYear,
				week: week,
				type: type,
			};
			onChange(param);
			onFetch(!fetch);
		} else {
			const param = {
				...value,
				startDate: startDate,
				endDate: endYear,
				week: week,
			};
			onChange(param);
			onFetch(!fetch);
		}
	}
	return (
		<HStack>
			<Select
				value={value.pool}
				disabled={isLoading}
				onChange={(e) => {
					onChange({ ...value, pool: e.target.value });
				}}
			>
				{poolOptions.map((o) => (
					<option color={"#000000"} key={o.key} value={o.key}>
						{o.name}
					</option>
				))}
			</Select>
			<Select
				value={value.type}
				disabled={isLoading}
				onChange={(e) => {
					dayMonthSelector(e);
				}}
			>
				{viewTypeOptions.map((o) => (
					<option key={o.key} value={o.key}>
						{o.name}
					</option>
				))}
			</Select>
			{/* need to change the label when year type selected */}
			<Select
				value={year}
				disabled={isLoading}
				onChange={(e) => {
					setYear(e.target.value);
					filter(e.target.value, endYear, selectedWeek.toString());
				}}
			>
				{yearList.map((o) => (
					<option key={o.key} value={o.key}>
						{o.name}
					</option>
				))}
			</Select>
			{selectedDayMonth !== "month" && (
				<Select
					value={selectedWeek.toString()}
					disabled={isLoading}
					onChange={(e) => {
						setSelectedWeek(Number(e.currentTarget.value));
						filter(year, endYear, e.currentTarget.value);
					}}
				>
					{weekNumberList.map((o) => (
						<option key={o.key} value={o.key}>
							{o.name}
						</option>
					))}
				</Select>
			)}
		</HStack>
	);
};

export default Filter;
